/* global Sys, Core, Services, Language */
Sys.ns("Core");

/**
 * Bonus Message controller.
 *
 * @class Core.BonusMessageController
 * @extends Core.Controller
 */
Core.BonusMessageController = {

    /**
     * @inheritdoc
     */
    constructor: function() {
        Core.BonusMessageController.superclass.constructor.apply(this, arguments);
    },

    /**
     * @protected
     * @inheritdoc
     */
    setupEvents: function() {
        this.on({
            "notify:responseParser.responseParsed": this.onServerResponse,
            "notify:stateHandler.enteringIdleState": this.showBonusMessageDialog
        });
    },

    /**
     * Handles server response.
     *
     * @protected
     * @param {Object} response The parsed response object.
     * @returns {void}
     */
    onServerResponse: function(response) {
        var value;

        if (Sys.isNumber(response.bonusAwarded)) {
            value = response.bonusAwarded.toFixed(2);
        }

        this.model.storeData("bonusAwarded", value);
    },

    /**
     * Displays bonus message dialog if message has been stored previously.
     *
     * @protected
     * @returns {void}
     */
    showBonusMessageDialog: function() {
        var value = this.model.readData("bonusAwarded");

        if (Sys.isDefined(value)) {
            this.requestDialog(value);
            this.model.setState("dialogOpen");
        }
    },

    /**
     * Requests dialog to be shown by firing event.
     *
     * @protected
     * @param {number} value Value to be displayed.
     * @returns {void}
     */
    requestDialog: function(value) {
        var dialogConfig = this.getDialog(value);

        Services.dialog.show(dialogConfig);
    },

    /**
     * Retrieves the dialog config.
     *
     * @protected
     * @param {number} value Value for bonus awarded.
     * @returns {IDialogConfig} Dialog object.
     */
    getDialog: function(value) {
        var me = this;

        return {
            title: Services.languageManager.getText(Language.Keys.bonusAwardedTitle),
            text: Services.languageManager.getText(Language.Keys.bonusAwardedCongrats, [value]),
            buttons: [
                {
                    text: Services.languageManager.getText(Language.Keys.btn_continue),
                    action: function() {
                        me.fireEvent("notify:dialogBoxClosed", { name: "bonusMessage", button: "continue" });
                    },
                    primary: true
                }
            ]
        };
    }
};

Core.BonusMessageController = Sys.extend(Core.Controller, Core.BonusMessageController, "Core.BonusMessageController");
